<template>
  <page :title="$tc('banner._name')">
    <div slot="page-header-right">
      <button @click="create" class="button is-primary">{{$tc('add.banner')}}</button>
    </div>

    <div class="box">
      <b-input type="search" icon="magnify" @input="search" :placeholder="$tc('banner._name')+' '+$tc('name')"></b-input>

      <hr />

      <b-table
        class="is-middle"
        :loading="banners.loading"
        :data="banners.data"
        :current-page="banners.current_page"
        :per-page="banners.per_page"
        :total="banners.total"
        @page-change="
          page => {
            banners.changePage(page);
          }
        "
        paginated
        backend-pagination
        pagination-position="bottom"
      >
        <template slot-scope="props">
          <b-table-column custom-key="slider" label="Slider Name">
            <router-link v-if="props.row.slider"
              :to="'/marketing/sliders/' +props.row.slider.id"
            >{{ props.row.slider ? props.row.slider.name : "-" }}</router-link>
          </b-table-column>

          <b-table-column custom-key="name" :label="$tc('banner._name')+' '+$tc('name')">
            <router-link
              :to="'/marketing/banners/' + props.row.id"
            >{{ props.row.name ? props.row.name : "-" }}</router-link>
          </b-table-column>

          <b-table-column custom-key="image" label="Image">
            <img
              v-if="props.row.content_type === 'image'"
              :src="props.row.media.sm"
              style="height: 50px;"
            />

            <video
              v-if="props.row.content_type === 'video'"
              :src="props.row.media.sm"
              style="height: 50px;"
            ></video>
          </b-table-column>

          <b-table-column :label="$tc('support_ticket.status._name')">
            <strong>{{ props.row.status }}</strong>
          </b-table-column>

          <b-table-column label="Start Date">
            <b-tooltip
              v-if="props.row.starts_at"
              :label="props.row.starts_at"
            >{{ props.row.starts_at | date }}</b-tooltip>
          </b-table-column>

          <b-table-column label="End Date">
            <b-tooltip
              v-if="props.row.ends_at"
              :label="props.row.ends_at"
            >{{ props.row.ends_at | date }}</b-tooltip>
          </b-table-column>

          <b-table-column>
            <div class="is-pulled-right">
              <button class="button mr-2 is-danger is-outlined" @click="destroy(props.row.id)" >Delete</button>
              <router-link class="button" :to="`/marketing/banners/${props.row.id}`">Edit</router-link>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
import _ from "lodash";

export default {
  data() {
    return {
      banners: new window.PaginatedRemoteCollection(
        "/admin/api/marketing/banners"
      )
        .perPage(8)
        .load()
    };
  },

  methods: {
    create() {
      this.$http.post("/admin/api/marketing/banners").then(response => {
        this.$router.push("/marketing/banners/" + response.data.data.id);
      });
    },

    destroy(data) {
      this.$buefy.dialog.confirm({
        title: "Deleting banner?",
        message: "This action is permenant.",
        cancelText: "Cancel",
        confirmText: "Delete banner",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$http
            .delete(`/admin/api/marketing/banners/${data}`)
            .then(() => {
              this.banners.load();

              this.$buefy.toast.open({
                type: "is-success",
                message: "Banner deleted."
              });
            });
        }
      });
    },

    search: _.throttle(function(search) {
      this.banners.filter({ search }).load();
    }, 300)
  }
};
</script>
